import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Location } from '@angular/common';
import { IPageViewModel } from '../pages';
import { ActivatedRoute } from '@angular/router';
import { ShellService } from 'src/app/shell/shell.service';


@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {

  constructor(private location: Location, private activatedRoute: ActivatedRoute, private shellService: ShellService) { }

  @Input() vm: IPageViewModel;

  @Input() title: string = "page-header";
  @Input() subTitle: string = undefined;

  @Input() headingSize: number = 1;

  @Input() dangerText: string = undefined;

  @Input() fullHeader: boolean = false;

  @Input() canGoBack: boolean = false;
  @Input() canRefresh: boolean = false;
  @Input() canAddNew: boolean = false;
  @Input() canExportExcel: boolean = false;

  @Output() refreshClick = new EventEmitter<any>();
  @Output() addNewClick = new EventEmitter<any>();
  @Output() exportExcelClick = new EventEmitter<any>();

  @Input() hidden: boolean = false;

  /**
   * 
   */
  goBack() {
    if (this.canGoBack)
      this.location.back();
  }

  /**
   * 
   */
  refresh() {
    if (this.vm.refresh)
      this.vm.refresh();
    else if (this.canRefresh)
      this.refreshClick.emit();
  }

  /**
   * 
   */
  add() {
    if (this.vm.addNew)
      this.vm.addNew(this.vm, this.vm.contentVm);
    else if (this.canAddNew)
      this.addNewClick.emit();
  }

  exportExcel() {
    if (this.vm.exportExcel)
      this.vm.exportExcel(this.vm, this.vm.contentVm);
    else if (this.canExportExcel)
      this.exportExcelClick.emit();
  }

  ngOnInit() {
    this.hidden = this.shellService.isOneTime()

    this.canGoBack = this.vm.canGoBack !== undefined ? this.vm.canGoBack : this.canGoBack;
    this.canAddNew = this.vm.canAddNew !== undefined ? this.vm.canAddNew : this.canAddNew;
    this.canRefresh = this.vm.canRefresh != undefined ? this.vm.canRefresh : this.canRefresh;
  }

}

